import { render, staticRenderFns } from "./ApplictionHerbMedicine.vue?vue&type=template&id=41ac8f76&scoped=true"
import script from "./ApplictionHerbMedicine.vue?vue&type=script&lang=js"
export * from "./ApplictionHerbMedicine.vue?vue&type=script&lang=js"
import style0 from "./ApplictionHerbMedicine.vue?vue&type=style&index=0&id=41ac8f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ac8f76",
  null
  
)

export default component.exports